import { Controller } from 'stimulus'

export default class extends Controller {
  // PUBLIC
  static targets = ['submitButton', 'selectMultipleComponent', 'errorMsgContainer', 'inputContainer', 'specificLocationsInput']

  static values = {
    areElementsSelected: Boolean
  }

  validateSelect(event) {
    const updateError = this.updateErrorParam(event.currentTarget)
    setTimeout(() => {
      this.areElementsSelectedValue = this.areElementsSelected
      this.refreshAll(updateError)
    }, 0)
  }

  // PRIVATE
  connect() {
    this.validateSelect()
  }

  get areElementsSelected() {
    const elementsSelectedCount = this.selectMultipleComponentTarget.querySelectorAll("input[type='checkbox']:checked").length
    return elementsSelectedCount > 0
  }

  refreshAll(updateError = true) {
    if (!this.specificLocationsInputTarget.checked) {
      this.submitButtonTarget.removeAttribute('disabled')
      return
    }

    const isSelectInvalid = !this.hasAreElementsSelectedValue || !this.areElementsSelectedValue

    if (updateError) { this.showError(isSelectInvalid) }
    this.disableSubmit(isSelectInvalid)
  }

  disableSubmit(disable) {
    if (disable) {
      this.submitButtonTarget.setAttribute('disabled', 'disabled')
    } else {
      this.submitButtonTarget.removeAttribute('disabled')
    }
  }

  showError(showError) {
    if (showError) {
      this.errorMsgContainerTarget.classList.add('pt-2')
      this.inputContainerTarget.classList.add('border-red-0')
      this.errorMsgContainerTarget.innerHTML = 'Please select at least 1 location'
    } else {
      this.errorMsgContainerTarget.innerHTML = ''
      this.errorMsgContainerTarget.classList.remove('pt-2')
      this.inputContainerTarget.classList.remove('border-red-0')
    }
  }

  updateErrorParam(elem) {
    const paramAttrName = `data-${this.identifier}-update-error-param`
    const param = elem.getAttribute(paramAttrName) !== 'false'
    return param
  }
}
